import moment from "moment"
import "moment/locale/pt-br"
import LoginService from "../../services/LoginService"
import { chaveArmazenamentoIdSessao, chaveArmazenamentoToken, USA_APPLET_SIM } from "../../shared/utils/Constantes"
import { verificarApplet } from "../../shared/utils/utils"
import * as loginActions from "./redux/loginActions"
import LaboratorioService from "../../services/LaboratorioService"

export let dadosAcesso = null;
const TEMPO_RENOVACAO_SESSAO = 120

export const atualizarDadosAcesso = (idSessao) => async (dispatch) => {
	if (!idSessao) return limparDadosAcessoEStorage(dispatch)

	try {
		const resposta = await autenticarUsuario(idSessao)

		if (resposta && resposta.dadosAcesso) {
			atualizarDadosUsuario(resposta.dadosAcesso, idSessao, dispatch)
			dadosAcesso = resposta.dadosAcesso
		} else {
			limparDadosAcessoEStorage(dispatch)
		}
	} catch (error) {
		limparDadosAcessoEStorage(dispatch)
	}
}

const limparDadosAcessoEStorage = (dispatch) => {
	localStorage.removeItem(chaveArmazenamentoIdSessao)
	localStorage.removeItem(chaveArmazenamentoToken)
	dispatch(loginActions.limparDadosAcesso())
}

const atualizarDadosUsuario = (dadosAcesso, idSessao, dispatch) => {
	localStorage.setItem(chaveArmazenamentoIdSessao, idSessao);
	localStorage.setItem(chaveArmazenamentoToken, dadosAcesso.tokenJwt);

	dispatch(loginActions.atualizarDadosAcesso(dadosAcesso))

	dispatch(dispararTempoExpiracao(dadosAcesso.dataAgora, dadosAcesso.dataExpiracao, idSessao, dadosAcesso.tokenJwt))
}

async function autenticarUsuario(idSessao) {
	return await LoginService.autenticarUsuario(idSessao, { handleError: false })
		.then((resposta) => {
			const dadosAcesso = {
				laboratorio: {
					...resposta.data.laboratorio,
					usaApplet: verificarApplet(resposta.data.laboratorio.usaApplet)
				},
				usuario: resposta.data.usuario,
				dataExpiracao: resposta.data.dataExpiracao,
				dataAgora: resposta.data.dataAgora,
				tokenJwt: resposta.data.tokenJwt,
				loginExterno: resposta.data.loginExterno,
			}
			return { dadosAcesso: dadosAcesso }
		})
		.catch((erro) => null)
}

export const dispararTempoExpiracao = (dataAgora, dataExpiracao, idSessao, tokenJwt) => async (dispatch) => {
	if (!dataExpiracao) loginActions.limparDadosAcesso()

	let periodoEmSegundos = 1
	let tempoContadorSessao = TEMPO_RENOVACAO_SESSAO

	if (moment(dataExpiracao).isAfter(dataAgora)) {
		periodoEmSegundos = moment
			.duration(moment(dataExpiracao, "YYYY/MM/DD HH:mm").diff(moment(dataAgora, "YYYY/MM/DD HH:mm")))
			.asSeconds()

		if (periodoEmSegundos > TEMPO_RENOVACAO_SESSAO) {
			periodoEmSegundos = periodoEmSegundos - TEMPO_RENOVACAO_SESSAO
		} else {
			tempoContadorSessao = periodoEmSegundos
			periodoEmSegundos = 1
		}
	}

	setTimeout(() => {
		dispatch(loginActions.expirarSessao(tempoContadorSessao))
	}, periodoEmSegundos * 1000)
}

export const autenticarLoginSenha = async (login, senha) => {
	const resposta = await LoginService
		.autenticar(login, senha)
	return resposta && resposta.data
}

export const autenticarComLaboratorio = (login, senha, codigoLaboratorio, idSessao) => async (dispatch) => {
	try {
		let dadosAcesso = {}

		await LoginService
			.autenticarComLaboratorio(login, senha, codigoLaboratorio, idSessao).then((resposta) => {
				dadosAcesso = {
					laboratorio: {
						...resposta.data.laboratorio,
						usaApplet: verificarApplet(resposta.data.laboratorio.usaApplet)
					},
					usuario: resposta.data.usuario,
					dataExpiracao: resposta.data.dataExpiracao,
					dataAgora: resposta.data.dataAgora,
					tokenJwt: resposta.data.tokenJwt,
					loginExterno: resposta.data.loginExterno,
				}
			})

		if (dadosAcesso) {
			atualizarDadosUsuario(dadosAcesso, idSessao, dispatch)
		} else {
			limparDadosAcessoEStorage(dispatch)
		}
	} catch (error) {
		limparDadosAcessoEStorage(dispatch)
	}
}

export const trocarLaboratorio = (codigoLaboratorio) => async (dispatch) => {
	try {
		const resposta = await LoginService.trocarLaboratorioUsuario(codigoLaboratorio);

		if (resposta.data) {
			atualizarDadosUsuario(resposta.data, resposta.data.idSessao, dispatch)
			dadosAcesso = resposta.data
			window.location.reload();
		} else {
			limparDadosAcessoEStorage(dispatch)
		}
	} catch (error) {
		limparDadosAcessoEStorage(dispatch)
	}
}

export const listarLaboratorios = async (termo) => {
	const resposta = await LaboratorioService.listarLaboratorios(termo);
	return resposta && resposta.data
}
